import React, { useCallback } from 'react';

import classNames from 'classnames';

import PlusSymbolFilled from '@travauxlib/shared/src/components/DesignSystem/assets/PlusSymbolFilled.svg?react';

import { ActionListIconContainer } from './ActionListIconContainer';
import { NewEntryButton } from './NewEntryButton';

import type { NewEntryItemType } from './type';

type Props = {
  closeActionList?: () => void;
  small?: boolean;
} & NewEntryItemType;

export const NewEntryItem: React.FC<Props> = ({
  label,
  onClick,
  closeActionList,
  disabled,
  active,
  selected,
  small,
}) => {
  const refinedOnClick = useCallback(() => {
    onClick();
    closeActionList?.();
  }, [onClick, closeActionList]);

  const icon = <PlusSymbolFilled />;

  return (
    <NewEntryButton
      refinedOnClick={refinedOnClick}
      disabled={disabled}
      active={active}
      selected={selected}
      small={small}
    >
      <ActionListIconContainer
        small={small}
        className={classNames('mr-xs', { 'text-disabled': disabled })}
        disabled={disabled}
      >
        {icon}
      </ActionListIconContainer>
      <span className={classNames('whitespace-nowrap text-b2', { 'text-b3!': small })}>
        {label}
      </span>
    </NewEntryButton>
  );
};
